import { useAtalhoDeAtendimento } from "@/lib/em-atendimento";
import { AtendimentoEmCursoBotao } from "../AtendimentoEmCursoBotao";
import { ALTURA_DA_BARRA } from "./BarraDeAbas";
import { useOcupaRodape } from "@/components/ajuda/RodapeOcupado";
import { useTecladoAberto } from "./use-teclado-aberto";

/** No celular o atalho do atendimento em curso sai da barra superior (o topo é do seletor) e vira
 *  uma faixa logo acima da barra de abas — à mão do polegar, só enquanto o atendimento dura. */
export function FaixaDeAtendimento() {
  const atalho = useAtalhoDeAtendimento();
  const teclado = useTecladoAberto();
  const ocupaRodape = useOcupaRodape<HTMLDivElement>();
  if (!atalho || teclado) return null;
  return (
    <div
      ref={ocupaRodape}
      className="fixed inset-x-0 z-30 flex justify-center px-3 pb-2 md:hidden"
      style={{ bottom: `calc(${ALTURA_DA_BARRA} + env(safe-area-inset-bottom))` }}
    >
      {/* Flutua sobre o conteúdo: sombra além do fundo e da borda que o botão já tem. */}
      <div className="rounded-full bg-white shadow-lg dark:bg-card">
        <AtendimentoEmCursoBotao />
      </div>
    </div>
  );
}
